import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BiArrowBack } from "react-icons/bi";

const AddNiosPricing = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();
  const [niosClass, setNiosClass] = useState([]);
  const [niosClassId, setNiosClassId] = useState();
  const [niosSubject, setNiosSubject] = useState([]);
  const [niosSubjectId, setNiosSubjectId] = useState();
  const [price, setPrice] = useState();

  // Fetch the class names
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/niosClasses`)
      .then((resp) => {
        const { data } = resp;
        // console.log(resp.data);
        // console.log(data);
        setNiosClass(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // Fetch subjects based on selected class name
  useEffect(() => {
    if (niosClassId) {
      axios
        .get(`${API_BASE_URL}/niosSubjects?classId=${niosClassId}`)
        .then((result) => {
          const { data } = result;
          setNiosSubject(data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [niosClassId]);

  const handleAddNiosPricing = () => {
    navigate("/exam-notes-pricing/add-nios-pricing");
  };
  const handleViewAllNiosPricing = () => {
    navigate("/exam-notes-pricing/all-nios-pricing");
  };
  const handleGoBack = () => {
    navigate("/exam-notes-pricing");
  };
  const payload = {
    niosSubjectId,
    price,
    type: "nios",
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post(`${API_BASE_URL}/admin/pricing/exam-notes`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((result) => {
        console.log(result);
        alert("Nios Notes Price Added.");
      })
      .catch((error) => {
        console.log(error);
        alert("Error while Adding Price.");
      });
  };
  return (
    <div id="exam-school-notes-inner-wrapper">
      <div className="main-header">
        <BiArrowBack
          onClick={handleGoBack}
          className="left-arrow-icon"
          style={{
            cursor: "pointer",
            display: "flex",
            fontSize: "25px",
            color: "#000",
          }}
        />
        <div className="exam-header-div">
          <h5>Nios Notes Pricing</h5>
          <div className="exam-btn-group">
            <button className="addNewNoteBtn" onClick={handleAddNiosPricing}>
              + Add Nios Pricing
            </button>
            <button
              className="viewAllNotesBtn"
              onClick={handleViewAllNiosPricing}
            >
              All Pricing
            </button>
          </div>
        </div>

        <div className="form-container" id="form">
          <h4 className="note-detail">Add Nios Note Price</h4>
          <form onSubmit={handleSubmit} className="note-detail-form">
            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Class Name</label>
              </div>
              <select
                className="select-dropdown"
                value={niosClassId}
                onChange={(e) => setNiosClassId(e.target.value)}
                required
              >
                <option value="">-Select Class-</option>
                {niosClass &&
                  niosClass.map((classes) => (
                    <option value={classes._id} key={classes._id}>
                      {classes?.className}
                    </option>
                  ))}
              </select>
            </div>

            <div className="new-chapter-form-group">
              <label className="new-chapter-label">Subject Name</label>
              <select
                className="new-chapter-dropdown"
                value={niosSubjectId}
                onChange={(e) => setNiosSubjectId(e.target.value)}
                required
              >
                <option value="">-Select Subject-</option>
                {niosSubject.map((subject, idx) => (
                  <option key={idx} value={subject._id}>
                    {subject.subjectName}
                  </option>
                ))}
              </select>
            </div>

            <div className="input-group">
              <label className="label">Note Price</label>
              <input
                type="text"
                className=""
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                placeholder="Enter Note Price"
                required
              />
            </div>

            <div className="form1-btns">
              <button className="btn-save">Save</button>
              <button
                type="button"
                className="btn-cancel"
                onClick={handleGoBack}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddNiosPricing;
